export var isForce = function isForce(layoutType) {
  return layoutType === 'force' || layoutType === 'g6force' || layoutType === 'gForce' || layoutType === 'force2';
};